// Chakra imports
import {
  Box,
  Flex,
  Grid,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import productImage1 from "assets/img/product-page-1.png";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import {HSeparator} from "components/Separator/Separator";
import React from "react";
import config from "../../../../config.json";

function OrderDetails({
                        Name, Email, PaymentMethod
                      }) {

  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgColor = useColorModeValue("#F8F9FA", "gray.800");
  const nameColor = useColorModeValue("gray.500", "white");

  return (
    <Flex justify="center" mx="auto" data-theme={config.style}>
      <Card maxW={{lg: "800px"}}>
        <CardBody>
          <Flex direction="column" w="100%">
            <HSeparator my="22px"/>
            <Grid
              templateColumns={{
                sm: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr",
              }}
              gap={{sm: "24px", lg: "54px"}}
            >
              <Flex direction="column">
                <Flex direction="column">
                  <Text
                    color={textColor}
                    fontSize="md"
                    fontWeight="bold"
                    mb="22px"
                  >
                    Betaalgegevens
                  </Text>
                  <Box p="24px" bg={bgColor} borderRadius="12px">
                    <Flex justify="space-between" w="100%">
                      <Flex direction="column">
                        <Text
                          color={nameColor}
                          fontSize="md"
                          fontWeight="bold"
                          mb="10px"
                        >
                        </Text>
                        <Text
                          color="gray.400"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Naam:{" "}
                          <Text as="span" color="gray.500" fontWeight="bold">
                            {Name}
                          </Text>
                        </Text>
                        <Text
                          color="gray.400"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Emailadres:{" "}
                          <Text as="span" color="gray.500" fontWeight="bold">
                            {Email}
                          </Text>
                        </Text>
                        <Text
                          color="gray.400"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Betaalmethode:{" "}
                          <Text as="span" color="gray.500" fontWeight="bold">
                            {PaymentMethod}
                          </Text>
                        </Text>
                      </Flex>
                    </Flex>
                  </Box>
                </Flex>
              </Flex>
              <Flex direction="column" gridColumn={{md: "1 / 3", lg: "auto"}}>
                <Text
                  color={textColor}
                  fontSize="md"
                  fontWeight="bold"
                  mb="22px"
                >
                  Samenvatting
                </Text>
                <Stack direction="column" spacing="12px">
                  <Flex align="center" justify="space-between">
                    <Text fontSize="sm" color="gray.400" fontWeight="normal">
                      Prijs:
                    </Text>
                    <Text fontSize="sm" color={textColor} fontWeight="bold">
                      {`€ ${(Number(config["premiumPrice"]) / 1.21).toFixed(2)}`}
                    </Text>
                  </Flex>
                  <Flex align="center" justify="space-between">
                    <Text fontSize="sm" color="gray.400" fontWeight="normal">
                      BTW:
                    </Text>
                    <Text fontSize="sm" color={textColor} fontWeight="bold">
                      {`€ ${((Number(config["premiumPrice"])) - (Number(config["premiumPrice"]) / 1.21)).toFixed(2)}`}
                    </Text>
                  </Flex>
                </Stack>
                <Flex align="center" justify="space-between" mt="24px">
                  <Text fontSize="md" color="gray.400" fontWeight="normal">
                    Totaal:
                  </Text>
                  <Text fontSize="md" color={textColor} fontWeight="bold">
                    {`€ ${Number(config["premiumPrice"]).toFixed(2)}`}
                  </Text>
                </Flex>
              </Flex>
            </Grid>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default OrderDetails;
